"use client";

;
import { useContext, useEffect, useRef, useState } from 'react';
import './../Topic/index.scss';
import TypoGraphy from '@/typography';
import useViewType from '@/utils/Hooks/useViewType';
import { projectImages } from 'public/Assets/Images';
import AbsoluteModal from '@/reusablecomponents/Modals/AbsoluteModal';
import Button from '@/uicomponents/Button';
import FaqSection from '@/reusablecomponents/FaqSection';
import { projectStrings } from '@/utils/projectstrings';
import CardSection from '@/reusablecomponents/CardSection';
import { useParams, useRouter } from 'next/navigation';
import { RouteStrings } from '@/utils/routestrings';
import { getSlugAndRouteName, handleVettedClick } from '@/utils/Functions';
import MentorDetails from '@/reusablecomponents/MentorDetails';
import Pagination from '@/reusablecomponents/Pagination';
import MobileFilter from '@/uicomponents/MobileFilter';
import ReviewerSection from '@/reusablecomponents/ReviewerSection';
import { SubTopic } from '../Topic';
import PlusReviewerImage from '@/reusablecomponents/PlusReviewersImage';
import { formatDateNormal } from '@/utils/Functions/formatDate';
import { AppContext } from '@/contexts/appcontext';
import { Courses } from '@/app/in/(their)/courses/FreeCourses';
const cardItems = ['Recognized as a LinkedIn Top startup', 'Trustpilot rating of 4.7/5', 'More than 400k total learners', 'Backed by 80+ Angel investors', 'Created by Industry Experts working at brands like'];
const SubTopicPage = ({
  coursesData,
  topicData,
  temp,
  topicIndustryData,
  filteredSubIndustries
}: any) => {
  const isMobile = useViewType();
  const [shareModal, setshareModal] = useState(false);
  const [fbhover, setfbhover] = useState(false);
  const [linkedinHover, setlinkedinHover] = useState(false);
  const [twitterHover, settwitterHover] = useState(false);
  const [pageNo, setpageNo] = useState(1);
  const [totalReadingTime, setTotalReadingTime] = useState(1);
  const {
    push
  } = useRouter();
  const mentorRef = useRef<any>(null);
  const params = useParams();
  const {
    routeId
  } = getSlugAndRouteName(params?.route?.toString() || '');
  const currentURL = typeof window !== 'undefined' ? window.location.href : '';
  const findTopicById = (id: number): any | undefined => {
    for (const topic of temp) {
      const foundSubTopic = topic.attributes.subTopics.find((subtopic: any) => subtopic.id === id);
      if (foundSubTopic) {
        return {
          data: [topic]
        };
      }
    }
    return {};
  };
  if (!topicData) {
    topicData = routeId ? findTopicById(routeId) : {};
  }
  const subTopics = topicData?.data[0].attributes.subTopics.map((subtopic: any, index: number) => {
    const subT = {
      ...subtopic
    };
    subT['serialId'] = index + 1;
    return subT;
  });
  const subTopicDetail = subTopics.find((subTopic: any) => subTopic.id === parseInt(routeId?.toString() ?? ''));
  const articles = subTopicDetail.articles;
  const articlesDivided = [];
  const hours = Math.floor(totalReadingTime / 60);
  const minutes = totalReadingTime % 60;
  const formattedTime = hours > 0 ? `${hours} hrs` : '' + (minutes > 0 ? ` ${minutes} mins` : '');
  let arr = [];
  for (let i = 0; i < articles.data.length; i++) {
    if (i !== 0 && i % 5 === 0) {
      articlesDivided.push(arr);
      arr = [];
    }
    arr.push(articles.data[i]);
    if (i === articles.data.length - 1) {
      articlesDivided.push(arr);
    }
  }
  const handlePageChange = (pageNo: number) => {
    setpageNo(pageNo);
    window.scrollTo(0, 0);
  };
  const reviewers = subTopics.reduce((array: Array<any>, subTopic: any) => {
    subTopic.articles.data.forEach((article: any) => array.push(article));
    return array;
  }, []).reduce((array: Array<any>, article: any) => {
    article?.attributes?.mentors?.data.forEach((mentorDetail: any) => array.push(mentorDetail));
    return array;
  }, []);
  const publishedAt: {
    date: Date;
    minutesRead: number;
  } = articles.data.reduce((publishedAt: {
    date: Date;
    minutesRead: number;
  }, article: any) => {
    let date = new Date(article.attributes.updatedAt);
    if (!date) {
      publishedAt.date = date;
    } else {
      publishedAt.date = date > publishedAt.date ? date : publishedAt.date;
    }
    !publishedAt.minutesRead ? publishedAt.minutesRead = article.attributes.minuteRead : publishedAt.minutesRead += article.attributes.minuteRead;
    return publishedAt;
  }, {
    date: '',
    minutesRead: 0
  });
  const coursessData = topicIndustryData?.data?.reduce((a: {
    freecourses: Array<any>;
    premCourses: Array<any>;
  }, b: any) => {
    if (b.attributes.isPremium) {
      a.premCourses.push(b);
    } else {
      a.freecourses.push(b);
    }
    return a;
  }, {
    freecourses: [],
    premCourses: []
  });
  const mouseEntered = useRef(false);
  const slicedReviewersImages = reviewers.slice(0, 3).map((reviewer: any) => reviewer.attributes.mentorImageUrl);
  const remainingTopics = subTopics.filter((subtopic: any) => {
    return subtopic.id !== parseInt(routeId?.toString() ?? '');
  });
  const totalArticles = subTopics.reduce((array: Array<any>, subTopic: any) => {
    subTopic.articles.data.forEach((article: any) => array.push(article));
    return array;
  }, []);
  const sortedCourses: Courses = coursesData?.data.reduce((courses: Courses, course: any) => {
    const industries = course.attributes.industries?.data;
    const subIndustries = course.attributes.subIndustries?.data;
    industries.forEach((industry: any) => {
      const {
        industryName
      } = industry.attributes;
      switch (industryName) {
        case "Product":
          if (!courses.product) {
            courses.product = {
              items: [],
              filters: {}
            };
          } else {
            courses.product.items.push(course);
            subIndustries.forEach((subindustry: any) => {
              let {
                subIndustry
              } = subindustry.attributes;
              courses.product.filters[subIndustry] = {
                name: subIndustry,
                id: subindustry.id
              };
            });
          }
          ;
          break;
        case "Marketing":
          if (!courses.marketing) {
            courses.marketing = {
              items: [],
              filters: {}
            };
          } else {
            courses.marketing.items.push(course);
            subIndustries.forEach((subindustry: any) => {
              let {
                subIndustry
              } = subindustry.attributes;
              courses.marketing.filters[subIndustry] = {
                name: subIndustry,
                id: subindustry.id
              };
            });
          }
          ;
          break;
        case "Design":
          if (!courses.design) {
            courses.design = {
              items: [],
              filters: {}
            };
          } else {
            courses.design.items.push(course);
            subIndustries.forEach((subindustry: any) => {
              let {
                subIndustry
              } = subindustry.attributes;
              courses.design.filters[subIndustry] = {
                name: subIndustry,
                id: subindustry.id
              };
            });
          }
          ;
          break;
        case "Data":
          if (!courses.dataIndustry) {
            courses.dataIndustry = {
              items: [],
              filters: {}
            };
          } else {
            courses.dataIndustry.items.push(course);
            subIndustries.forEach((subindustry: any) => {
              let {
                subIndustry
              } = subindustry.attributes;
              courses.dataIndustry.filters[subIndustry] = {
                name: subIndustry,
                id: subindustry.id
              };
            });
          }
          ;
          break;
        case "Business":
          if (!courses.business) {
            courses.business = {
              items: [],
              filters: {}
            };
          } else {
            courses.business.items.push(course);
            subIndustries.forEach((subindustry: any) => {
              let {
                subIndustry
              } = subindustry.attributes;
              courses.business.filters[subIndustry] = {
                name: subIndustry,
                id: subindustry.id
              };
            });
          }
          ;
          break;
        default:
          break;
      }
    });
    return courses;
  }, {});
  const handleMouseLeave = (e: any) => {
    setTimeout(() => {
      if (!mouseEntered.current) {
        setshareModal(false);
        setfbhover(false);
        setlinkedinHover(false);
        settwitterHover(false);
      }
    }, 500);
  };
  const {
    setTopic,
    setSubTopic
  } = useContext<any>(AppContext);
  useEffect(() => {
    setTopic(topicData?.data[0].attributes.topicName);
    setSubTopic(subTopicDetail?.subTopicName);
    setTotalReadingTime(totalArticles.reduce((total: number, obj: any) => total + obj.attributes.minuteRead, 0));
    const handleBodyClick = (e: any) => {
      const classNames = ['share_images', 'icon_image'];
      if (classNames.includes(e.target.className)) return;
      setshareModal(false);
    };
    document.body.addEventListener('click', handleBodyClick);
    return () => {
      setshareModal(false);
      document.body.removeEventListener('click', handleBodyClick);
    };
  }, []);
  return <>
            <div className="topic_page_wrapper">
                <div className="left_content_wrapper">
                    <div className="topic_header_content">
                        <div className="text_content">
                            <TypoGraphy text={subTopicDetail?.subTopicName} variant={isMobile ? 'Mobile/Heading' : 'Desktop/Heading 2'} tagName='h1' data-sentry-element="TypoGraphy" data-sentry-source-file="index.tsx" />
                            {/* <TypoGraphy text='Last updated on 26th Spet 2023, 8 min read' variant={'Desktop/Body 2/R | 14 |120'}  styles={{
                                paddingTop : "8px"
                             }}/> */}
                            <TypoGraphy text={`Last updated on ${formatDateNormal(publishedAt.date.toString())} • ${publishedAt.minutesRead} min read`} variant={!isMobile ? 'Desktop/Body 2/R | 14 |120' : 'Desktop/Caption/R | 12 |120'} styles={{
              opacity: "0.6",
              padding: isMobile ? "12px 0px 8px 0px" : "8px 0px"
            }} data-sentry-element="TypoGraphy" data-sentry-source-file="index.tsx" />
                            <TypoGraphy text={subTopicDetail?.description} variant={isMobile ? 'Mobile/Body 2' : 'Desktop/Body 1/R | 16 |160'} styles={{
              paddingTop: "16px",
              fontSize: !isMobile ? "20px" : "",
              fontWeight: !isMobile ? "400" : "",
              lineHeight: !isMobile ? "150%" : ""
            }} data-sentry-element="TypoGraphy" data-sentry-source-file="index.tsx" />
                        </div>
                        {!isMobile ? <div className="share_icon_wrapper">
                            <div className="share_icon_wrapper" onMouseEnter={() => {
              if (!isMobile) setshareModal(true);
            }} onMouseLeave={handleMouseLeave} onClick={() => {
              if (isMobile) window.navigator.share();
            }}>
                                <img src={shareModal ? projectImages.shareHover : projectImages.shareIconFilled} alt="share" />
                                {shareModal && <AbsoluteModal top={"50px"} right={"0"} onMouseEnter={() => mouseEntered.current = true} onMouseLeave={() => mouseEntered.current = false} styles={{
                boxShadow: '0px 75px 21px 0px rgba(0, 0, 0, 0.00), 0px 48px 19px 0px rgba(0, 0, 0, 0.01), 0px 27px 16px 0px rgba(0, 0, 0, 0.05), 0px 3px 7px 0px rgba(0, 0, 0, 0.10)'
              }}>
                                    <div className="share_images">
                                        <img className='icon_image' src={fbhover ? projectImages.fbDark : projectImages.facebook} onMouseEnter={() => setfbhover(true)} onMouseLeave={() => setfbhover(false)} alt="facebook" onClick={() => window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentURL)}`, '_blank')} />
                                        <img className='icon_image' src={linkedinHover ? projectImages.linkedinDark : projectImages.linkedin} onMouseEnter={() => setlinkedinHover(true)} onMouseLeave={() => setlinkedinHover(false)} alt="linkedin" onClick={() => window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentURL)}`, '_blank')} />
                                        <img className='icon_image' src={twitterHover ? projectImages.twitterDark : projectImages.twitter} onMouseEnter={() => settwitterHover(true)} onMouseLeave={() => settwitterHover(false)} alt="twitter" onClick={() => window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentURL)}`, '_blank')} />
                                    </div>
                                </AbsoluteModal>}</div>
                        </div> : <><div className="mobile_share_button" onClick={() => {
              if (!isMobile || !navigator) return;
              navigator.share({
                url: encodeURIComponent(currentURL)
              });
            }}>
                            <TypoGraphy text='Share' variant='Mobile/Body 2/R | 14 | 160' /><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path d="M9.05178 11.5118L5.64511 9.65379C5.31811 9.97839 4.90232 10.1989 4.45017 10.2875C3.99802 10.3762 3.52975 10.329 3.10439 10.1519C2.67904 9.97475 2.31564 9.67567 2.06001 9.29233C1.80438 8.90899 1.66797 8.45855 1.66797 7.99779C1.66797 7.53704 1.80438 7.0866 2.06001 6.70326C2.31564 6.31992 2.67904 6.02084 3.10439 5.84373C3.52975 5.66662 3.99802 5.61941 4.45017 5.70804C4.90232 5.79668 5.31811 6.0172 5.64511 6.34179L9.05178 4.48379C8.93494 3.93562 9.01933 3.3637 9.28951 2.87263C9.55969 2.38156 9.9976 2.00415 10.5232 1.80942C11.0487 1.61469 11.6269 1.61564 12.1518 1.81212C12.6767 2.00859 13.1134 2.38745 13.3819 2.87942C13.6505 3.37139 13.733 3.94358 13.6143 4.49136C13.4956 5.03915 13.1838 5.52592 12.7357 5.86266C12.2877 6.1994 11.7334 6.36361 11.1742 6.32526C10.615 6.28691 10.0883 6.04856 9.69044 5.65379L6.28378 7.51179C6.35164 7.83202 6.35164 8.16291 6.28378 8.48313L9.69044 10.3418C10.0883 9.94703 10.615 9.70868 11.1742 9.67033C11.7334 9.63198 12.2877 9.79619 12.7357 10.1329C13.1838 10.4697 13.4956 10.9564 13.6143 11.5042C13.733 12.052 13.6505 12.6242 13.3819 13.1162C13.1134 13.6081 12.6767 13.987 12.1518 14.1835C11.6269 14.3799 11.0487 14.3809 10.5232 14.1862C9.9976 13.9914 9.55969 13.614 9.28951 13.123C9.01933 12.6319 8.93494 12.06 9.05178 11.5118Z" fill="#030A21" />
                            </svg>
                        </div>
                        </>}
                    </div>
                    {reviewers?.length > 0 ? <div className="images_wrapper">
                        <div className="mentors_images_section">
                            {slicedReviewersImages.map((image: string, index: number) => {
              return <div className="rounded_absolute_image" style={index > 0 ? {
                marginLeft: "-10px"
              } : {}} key={`mentor_image_cl_${index}`}>
                                        <img src={image} alt="mentor" />
                                    </div>;
            })}
                            {reviewers.length - slicedReviewersImages.length > 0 && <div className="rounded_absolute_image" style={{
              marginLeft: "-10px"
            }}>
                                <PlusReviewerImage count={reviewers.length - slicedReviewersImages.length} />
                            </div>}
                        </div>
                        <img src={projectImages.createText} alt="created" onClick={() => handleVettedClick(mentorRef.current)} style={{
            cursor: "pointer"
          }} />
                    </div> : <div className="margin_bottom" style={{
          marginBottom: "40px"
        }}></div>}
                    <div className="topic_contents_wrapper">
                        <div className="subtopics">
                            {articlesDivided[pageNo - 1].map((article: any, index: number) => {
              const articleDetail = article.attributes;
              return <div className="sub_topic_detail_card" key={`sub_topic_card_${index}`} style={{
                marginTop: index === 0 && !isMobile ? "10px" : ""
              }}>
                                        <div className="sub_topic_heading">
                                            <TypoGraphy text={articleDetail.title} variant={isMobile ? 'Condensed/Mobile/Heading 1 | M | 24 | 140' : 'Condensed/Desktop/Heading 1 | M | 32 | 140'} tagName='h3' />
                                            <TypoGraphy text={`${formatDateNormal(articleDetail.updatedAt)} • ${articleDetail.minuteRead} min read`} variant={isMobile ? 'Mobile/Caption/R | 12 | 120' : 'Desktop/Body 2/R | 14 |120'} styles={{
                    opacity: "0.6"
                  }} />
                                        </div>
                                        <div className="mentors_section_sub_topic">
                                            {articleDetail?.mentors?.data?.length > 0 && <div className="written_by">
                                                <TypoGraphy text='Written By' variant={isMobile ? 'Mobile/Caption/R | 12 | 120' : 'Desktop/Body 2/R | 14 |120'} />
                                                <div className="mentors_list">
                                                    {articleDetail.mentors.data.map((mentor: any, index: number) => {
                        const mentorDetails = mentor.attributes;
                        return <MentorDetails name={mentorDetails.name} companyName={mentorDetails.companyName} designation={mentorDetails.designation} mentorImageUrl={mentorDetails.mentorImageUrl} key={`mentor_${mentor.id}`} />;
                      })}
                                                </div>
                                            </div>}
                                            {articleDetail?.reviewedBy?.data?.length > 0 && <div className="reviewed_by">
                                                <TypoGraphy text='Reviewed By' variant={isMobile ? 'Mobile/Caption/R | 12 | 120' : 'Desktop/Body 2/R | 14 |120'} />
                                                <div className="mentors_list">
                                                    {articleDetail.reviewedBy.data.map((mentor: any, index: number) => {
                        const mentorDetails = mentor.attributes;
                        return <MentorDetails name={mentorDetails.name} companyName={mentorDetails.companyName} designation={mentorDetails.designation} mentorImageUrl={mentorDetails.mentorImageUrl} key={`reviewed_by_${mentor.id}`} isReviewed />;
                      })}
                                                </div>
                                            </div>}
                                        </div>
                                        <div className="descr_wrapper">
                                            <TypoGraphy text={articleDetail.shortDescription} variant={isMobile ? 'Mobile/Body 2' : 'Desktop/Body 3'} />
                                        </div>
                                        {isMobile ? <div className="continue_reading" onClick={() => push(RouteStrings.DYNAMICROUTE(articleDetail.title, 'ARTICLE', article.id))}>
                                            <TypoGraphy text='Read More' variant='Mobile/Body 2/R | 14 | 160' />
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                <path d="M9.61914 3.95312L13.6658 7.99979L9.61914 12.0465" stroke="#292D32" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                                                <path d="M2.33203 8H13.552" stroke="#292D32" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>

                                        </div> : <a className="continue_reading" title={`Learn: ${articleDetail.title}`} href={RouteStrings.DYNAMICROUTE(articleDetail.title, 'ARTICLE', article.id)}>
                                            <TypoGraphy text='Continue Reading' variant='Desktop/Body 2/R | 14 |120' color='#030A2180' /> <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                                                <path fillRule="evenodd" clipRule="evenodd" d="M9.14947 3.92279C8.85658 3.6299 8.3817 3.6299 8.08881 3.92279C7.79592 4.21569 7.79592 4.69056 8.08881 4.98346L10.8554 7.75H1.33203C0.917818 7.75 0.582031 8.08579 0.582031 8.5C0.582031 8.91421 0.917818 9.25 1.33203 9.25H10.8549L8.08881 12.0161C7.79592 12.309 7.79592 12.7839 8.08881 13.0768C8.3817 13.3697 8.85658 13.3697 9.14947 13.0768L13.1961 9.03012C13.3368 8.88947 13.4158 8.6987 13.4158 8.49979C13.4158 8.30088 13.3368 8.11011 13.1961 7.96946L9.14947 3.92279Z" fill="#030A21" fillOpacity="0.3" />
                                            </svg>
                                        </a>}
                                    </div>;
            })}
                            {<div className="sub_topic_pagination_wrapper">
                                <Pagination onPageChange={handlePageChange} pageCount={articlesDivided.length} pageNo={pageNo} />
                            </div>}
                            {remainingTopics?.length > 0 && <> <div className="subtopic_heading">
                                <TypoGraphy text={'Continue Learning'} variant={isMobile ? 'Condensed/Mobile/Heading 1 | M | 24 | 140' : 'Condensed/Desktop/Heading 1 | M | 32 | 140'} tagName='h2' />
                            </div>
                                <div className="subtopic_list_wrapper">
                                    {remainingTopics.map((subtopic: any, index: number) => {
                  return <div className="" key={`sub_topic_${index}`}>
                                                <SubTopic subTopic={subtopic} />
                                            </div>;
                })}
                                </div> </>}
                        </div>
                    </div>
                    {/* <div className="description_text_wrapper">
                        <TypoGraphy text='Lorem Ipsum Dolor' variant={isMobile ? 'Condensed/Mobile/Heading 1 | M | 24 | 140' : 'Condensed/Desktop/Heading 1 | M | 32 | 140'} />
                         <TypoGraphy text='Lorem ipsum dolor sit amet consectetur, adipisicing elit. Distinctio voluptatibus voluptas eveniet recusandae? Illo perferendis eos sequi vitae accusamus voluptatem quaerat deleniti dolore, velit eligendi, nostrum, non officia veniam consequatur?'
                            variant={isMobile ? 'LP/Paragraph/Paragraph Small' : 'Desktop/Body 1/R | 16 |160'} />
                     </div> */}
                    {reviewers?.length > 0 && <div className="reviewers_wrapper" ref={mentorRef}>
                        <ReviewerSection data={reviewers ?? ''} title={`Vetted by Industry Experts in ${topicData.data[0].attributes.industry.data.attributes.industryName}`}></ReviewerSection>
                    </div>}
                    {subTopicDetail.subTopicfaq && <FaqSection data={subTopicDetail.subTopicfaq} />}
                </div>
                <div className="right_content_wrapper">
                    <div className="sticky_content">
                        <div className="card_one_wrapper">
                            <TypoGraphy text={`Learn ${topicData?.data[0].attributes.topicName}`} variant={'Condensed/Desktop/Heading 2 | M | 24 | 120'} data-sentry-element="TypoGraphy" data-sentry-source-file="index.tsx" />
                            <div className="contents_wrapper">
                                <div className="item_wrapper">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="20" viewBox="0 0 19 20" fill="none" data-sentry-element="svg" data-sentry-source-file="index.tsx">
                                        <path d="M17.4167 7.25151V3.65734C17.4167 2.54109 16.91 2.08984 15.6512 2.08984H12.4529C11.1942 2.08984 10.6875 2.54109 10.6875 3.65734V7.24359C10.6875 8.36776 11.1942 8.81109 12.4529 8.81109H15.6512C16.91 8.81901 17.4167 8.36776 17.4167 7.25151Z" fill="#B3B5BC" data-sentry-element="path" data-sentry-source-file="index.tsx" />
                                        <path d="M17.4167 16.1512V12.9529C17.4167 11.6942 16.91 11.1875 15.6512 11.1875H12.4529C11.1942 11.1875 10.6875 11.6942 10.6875 12.9529V16.1512C10.6875 17.41 11.1942 17.9167 12.4529 17.9167H15.6512C16.91 17.9167 17.4167 17.41 17.4167 16.1512Z" fill="#B3B5BC" data-sentry-element="path" data-sentry-source-file="index.tsx" />
                                        <path d="M8.31217 7.25151V3.65734C8.31217 2.54109 7.80551 2.08984 6.54676 2.08984H3.34842C2.08967 2.08984 1.58301 2.54109 1.58301 3.65734V7.24359C1.58301 8.36776 2.08967 8.81109 3.34842 8.81109H6.54676C7.80551 8.81901 8.31217 8.36776 8.31217 7.25151Z" fill="#B3B5BC" data-sentry-element="path" data-sentry-source-file="index.tsx" />
                                        <path d="M8.31217 16.1512V12.9529C8.31217 11.6942 7.80551 11.1875 6.54676 11.1875H3.34842C2.08967 11.1875 1.58301 11.6942 1.58301 12.9529V16.1512C1.58301 17.41 2.08967 17.9167 3.34842 17.9167H6.54676C7.80551 17.9167 8.31217 17.41 8.31217 16.1512Z" fill="#B3B5BC" data-sentry-element="path" data-sentry-source-file="index.tsx" />
                                    </svg>
                                    <TypoGraphy text={`${topicData?.data[0].attributes.subTopics.length} Sub Topics`} variant='Desktop/Body 2/R | 14 |120' data-sentry-element="TypoGraphy" data-sentry-source-file="index.tsx" />
                                </div>
                                <div className="item_wrapper">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" data-sentry-element="svg" data-sentry-source-file="index.tsx">
                                        <path d="M13.1648 1.83621C12.8231 1.49454 12.2314 1.72788 12.2314 2.20288V5.11121C12.2314 6.32787 13.2648 7.33621 14.5231 7.33621C15.3148 7.34454 16.4148 7.34454 17.3564 7.34454C17.8314 7.34454 18.0814 6.78621 17.7481 6.45287C16.5481 5.24454 14.3981 3.06954 13.1648 1.83621Z" fill="#B3B5BC" data-sentry-element="path" data-sentry-source-file="index.tsx" />
                                        <path d="M17.085 8.49883H14.6766C12.7016 8.49883 11.0933 6.89049 11.0933 4.91549V2.50716C11.0933 2.04883 10.7183 1.67383 10.26 1.67383H6.72663C4.15996 1.67383 2.08496 3.34049 2.08496 6.3155V13.6988C2.08496 16.6738 4.15996 18.3405 6.72663 18.3405H13.2766C15.8433 18.3405 17.9183 16.6738 17.9183 13.6988V9.33216C17.9183 8.87383 17.5433 8.49883 17.085 8.49883ZM9.58496 14.7988H6.25163C5.90996 14.7988 5.62663 14.5155 5.62663 14.1738C5.62663 13.8322 5.90996 13.5488 6.25163 13.5488H9.58496C9.92663 13.5488 10.21 13.8322 10.21 14.1738C10.21 14.5155 9.92663 14.7988 9.58496 14.7988ZM11.2516 11.4655H6.25163C5.90996 11.4655 5.62663 11.1822 5.62663 10.8405C5.62663 10.4988 5.90996 10.2155 6.25163 10.2155H11.2516C11.5933 10.2155 11.8766 10.4988 11.8766 10.8405C11.8766 11.1822 11.5933 11.4655 11.2516 11.4655Z" fill="#B3B5BC" data-sentry-element="path" data-sentry-source-file="index.tsx" />
                                    </svg>
                                    <TypoGraphy text={`${totalArticles.length} Articles`} variant='Desktop/Body 2/R | 14 |120' data-sentry-element="TypoGraphy" data-sentry-source-file="index.tsx" />
                                </div>
                                <div className="item_wrapper">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" data-sentry-element="svg" data-sentry-source-file="index.tsx">
                                        <path d="M10.0003 1.66602C5.40866 1.66602 1.66699 5.40768 1.66699 9.99935C1.66699 14.591 5.40866 18.3327 10.0003 18.3327C14.592 18.3327 18.3337 14.591 18.3337 9.99935C18.3337 5.40768 14.592 1.66602 10.0003 1.66602ZM13.6253 12.9743C13.5087 13.1743 13.3003 13.2827 13.0837 13.2827C12.9753 13.2827 12.867 13.2577 12.767 13.191L10.1837 11.6493C9.54199 11.266 9.06699 10.4243 9.06699 9.68268V6.26602C9.06699 5.92435 9.35033 5.64102 9.69199 5.64102C10.0337 5.64102 10.317 5.92435 10.317 6.26602V9.68268C10.317 9.98268 10.567 10.4243 10.8253 10.5743L13.4087 12.116C13.7087 12.291 13.8087 12.6743 13.6253 12.9743Z" fill="#B3B5BC" data-sentry-element="path" data-sentry-source-file="index.tsx" />
                                    </svg>
                                    <TypoGraphy text={formattedTime} variant='Desktop/Body 2/R | 14 |120' data-sentry-element="TypoGraphy" data-sentry-source-file="index.tsx" />
                                </div>

                            </div>
                            <div className="card_button_wrapper">
                                <Button text='Start Learning' variant='NormalVariant' textColor='white' backgroundColor='#030A21' textVariant={'Desktop/Body 1/M | 16 |120'} clickHandler={() => push(RouteStrings.DYNAMICROUTE(articles.data[0].attributes.title, 'ARTICLE', articles.data[0].id))} data-sentry-element="Button" data-sentry-source-file="index.tsx" />
                            </div>
                        </div>
                        <div className="card_two_wrapper">
                            <TypoGraphy text='Why GrowthSchool?' variant={'Condensed/Desktop/Heading 2 | M | 24 | 120'} data-sentry-element="TypoGraphy" data-sentry-source-file="index.tsx" />
                            <div className="contents_wrapper">
                                {cardItems.map((item: string, index: number) => {
                return <div className="item_wrapper" key={`card_items_${index}`}>
                                            <img src={projectImages.greenTick} alt="tick" />
                                            <TypoGraphy text={item} variant='Desktop/Body 2/R | 14 |120' />
                                        </div>;
              })}
                            </div>
                            <img src={projectImages.cardcompanies} alt="companies" />
                        </div>
                    </div>
                </div>

            </div>
            <div className="topics_card_section" style={{
      marginTop: isMobile ? "40px" : ""
    }}>
                <CardSection data={{
        cards: coursessData?.premCourses,
        filters: filteredSubIndustries
      }} isFilterArray industryName={topicData.data[0].attributes.industry.data.attributes.industryName} title={"Related Premium " + topicData.data[0].attributes.industry.data.attributes.industryName + "Courses"} styles={{
        background: isMobile ? "white" : ""
      }} data-sentry-element="CardSection" data-sentry-source-file="index.tsx" />
                <CardSection data={{
        cards: coursessData?.freecourses,
        filters: filteredSubIndustries
      }} isFilterArray industryName={topicData.data[0].attributes.industry.data.attributes.industryName} title={"Related Free " + topicData.data[0].attributes.industry.data.attributes.industryName + " Certification Courses"} data-sentry-element="CardSection" data-sentry-source-file="index.tsx" />
            </div>
            <MobileFilter leraningClick={() => push(RouteStrings.DYNAMICROUTE(articles.data[0].attributes.title, 'ARTICLE', articles.data[0].id))} data-sentry-element="MobileFilter" data-sentry-source-file="index.tsx" />
        </>;
};
export default SubTopicPage;